import { useState } from "react";
import type { Episode } from "@/types/movie";

interface EpisodeListProps {
  episodes: Episode[];
}

export default function EpisodeList({ episodes }: EpisodeListProps) {
  const [activeId, setActiveId] = useState(episodes[0]?.id ?? "");
  const active = episodes.find((item) => item.id === activeId) ?? episodes[0];

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-6">
      <div className="mb-4 flex items-center gap-2">
        <i className="ri-list-check-2 text-accent-600 text-lg"></i>
        <h2 className="font-heading text-lg font-bold text-foreground-950">
          剧集列表
        </h2>
        <span className="text-sm text-foreground-500">共 {episodes.length} 集</span>
      </div>

      <div className="flex gap-4 md:gap-6">
        <div className="flex max-h-[320px] w-full flex-col gap-1 overflow-y-auto pr-1 sm:w-56 sm:shrink-0">
          {episodes.map((episode) => (
            <button
              key={episode.id}
              type="button"
              onClick={() => setActiveId(episode.id)}
              className={`rounded-md px-3 py-2.5 text-left text-sm transition-colors whitespace-nowrap ${
                episode.id === active?.id
                  ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {episode.title}
            </button>
          ))}
        </div>

        {active && (
          <div className="hidden flex-1 rounded-md border border-background-200 bg-background-100 p-5 sm:block">
            <h3 className="font-heading text-base font-bold text-foreground-950">
              {active.title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              {active.summary}
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
              <i className="ri-information-line"></i>
              本页面仅展示剧集简介信息，不提供在线播放功能
            </p>
          </div>
        )}
      </div>

      {/* 移动端：滑动卡片列表 */}
      <div className="mt-4 flex gap-3 overflow-x-auto pb-1 sm:hidden scrollbar-hide">
        {episodes.map((episode) => (
          <button
            key={episode.id}
            type="button"
            onClick={() => setActiveId(episode.id)}
            className={`w-60 shrink-0 rounded-md border p-4 text-left ${
              episode.id === active?.id
                ? "border-primary-400 bg-primary-100/60"
                : "border-background-200 bg-background-100"
            }`}
          >
            <h3 className="font-heading text-sm font-bold text-foreground-950">
              {episode.title}
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600 line-clamp-3">
              {episode.summary}
            </p>
          </button>
        ))}
      </div>
    </div>
  );
}